export const generateEQ = async(data) => {
    const reqData = {
        keyword_data: data,
    }
    let res = []
    try {
        const response = await fetch('https://tool.talans.cn/api/generate_eq', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(reqData),
        });

        if (!response.ok) {
            throw new Error('Network generateEQ response was not ok');
        }

        const resData = await response.json();
        if (resData['err']) {
            console.error('Error uploading file:', resData['err']);
            return
        }
        console.log("resData", resData)
        res = resData['data']

    } catch (error) {
        console.error('Error uploading file:', error);
    }
    console.log("res", res)
    return res
};
